"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _util = require("./util");

var _profileExternalActions = require("../actions/profile-external-actions");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  propertySearch: {
    corelogicPropertyId: '',
    streetAddress: '',
    streetName: '',
    addressMode: '',
    houseNumber: '',
    houseNumber2: '',
    city: '',
    state: '',
    streetSuffix: '',
    postDirection: '',
    unitNumber: '',
    zipCode: '',
    zip4: '',
    longitude: undefined,
    // number
    latitude: undefined,
    // number
    fipsCode: '',
    preDirection: '',
    parcelNumber: '',
    parcelSequence: '',
    carrierRoute: '',
    apn: '',
    universalParcelId: '',
    houseNumberSuffix: '',
    county: ''
  },
  avm: {
    avmValue: undefined,
    // number
    landUseCode: undefined,
    // number
    runDate: '',
    lastSaleDate: '',
    lastSaleValue: undefined // number

  },
  error: ''
};
exports.initialState = initialState;
var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, "".concat(_profileExternalActions.GET_ADDRESS_PROPERTY_DATA, "_").concat(_httpActions.REQUEST), function _(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    propertySearch: _objectSpread({}, initialState.propertySearch),
    avm: _objectSpread({}, initialState.avm),
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_profileExternalActions.GET_ESTIMATED_AVM_DATA, "_").concat(_httpActions.REQUEST), function _(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    avm: _objectSpread({}, initialState.avm),
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _reduxActions.combineActions)("".concat(_profileExternalActions.GET_ESTIMATED_AVM_DATA, "_").concat(_httpActions.FAILURE), "".concat(_profileExternalActions.GET_ADDRESS_PROPERTY_DATA, "_").concat(_httpActions.FAILURE)), function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    error: (0, _util.payloadError)(action)
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_profileExternalActions.GET_ADDRESS_PROPERTY_DATA, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var propertySearch = action.payload || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    propertySearch: {
      corelogicPropertyId: propertySearch.corelogicPropertyId || '',
      streetAddress: propertySearch.streetAddress || '',
      streetName: propertySearch.streetName || '',
      addressMode: propertySearch.addressMode || '',
      houseNumber: propertySearch.houseNumber || '',
      houseNumber2: propertySearch.houseNumber2 || '',
      city: propertySearch.city || '',
      state: propertySearch.state || '',
      streetSuffix: propertySearch.streetSuffix || '',
      postDirection: propertySearch.postDirection || '',
      unitNumber: propertySearch.unitNumber || '',
      zipCode: propertySearch.zipCode || '',
      zip4: propertySearch.zip4 || '',
      longitude: propertySearch.longitude || undefined,
      latitude: propertySearch.latitude || undefined,
      fipsCode: propertySearch.fipsCode || '',
      preDirection: propertySearch.preDirection || '',
      parcelNumber: propertySearch.parcelNumber || '',
      parcelSequence: propertySearch.parcelSequence || '',
      carrierRoute: propertySearch.carrierRoute || '',
      apn: propertySearch.apn || '',
      universalParcelId: propertySearch.universalParcelId || '',
      houseNumberSuffix: propertySearch.houseNumberSuffix || '',
      county: propertySearch.county || ''
    },
    error: ''
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_profileExternalActions.GET_ESTIMATED_AVM_DATA, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var avm = action.payload || {};
  return _objectSpread(_objectSpread({}, state), {}, {
    avm: {
      avmValue: avm.avmValue || undefined,
      landUseCode: avm.landUseCode || undefined,
      runDate: avm.runDate || '',
      lastSaleDate: avm.lastSaleDate || '',
      lastSaleValue: avm.lastSaleValue || undefined
    },
    error: ''
  });
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;